/**
 * Choose a workplace. Only reached when somebody belongs to more than one
 * tenant, which is rare; a single membership is selected automatically by the
 * session provider so nobody is asked a question with one answer.
 */
import { Building2, ChevronRight, LogOut } from 'lucide-react';
import { useSession } from '../lib/session.tsx';
import { Avatar, PandaMark } from '../components/Bits.tsx';

const ROLE_LABEL: Record<string, string> = {
  owner: 'Owner',
  manager: 'Manager',
  staff: 'Staff',
};

export default function TenantPickPage() {
  const { memberships, selectTenant, signOut, me } = useSession();

  return (
    <div className="flex min-h-screen items-center justify-center px-5 py-10">
      <div className="w-full" style={{ maxWidth: 440 }}>
        <div className="mb-6 flex flex-col items-center text-center">
          <PandaMark size={52} />
          <h1 className="mt-4 text-[21px] font-extrabold tracking-tight text-ink">Which workplace?</h1>
          <p className="mt-1 text-[13.5px] text-muted">Signed in as {me?.user.name}</p>
        </div>

        <div className="card card-lift overflow-hidden">
          {memberships.map((m, i) => (
            <button
              key={m.tenantId}
              type="button"
              onClick={() => selectTenant(m.tenantSlug)}
              className="row-link press flex w-full items-center gap-3 px-4 py-3.5 text-left"
              style={i > 0 ? { borderTop: '1px solid var(--sp-hairline)' } : undefined}
            >
              <Avatar name={m.tenantName} size={36} />
              <span className="min-w-0 flex-1">
                <span className="block truncate text-[14.5px] font-bold text-ink">{m.tenantName}</span>
                <span className="block truncate text-[12.5px] text-muted">{ROLE_LABEL[m.role] ?? m.role}</span>
              </span>
              <ChevronRight size={17} aria-hidden="true" className="row-chev" style={{ color: 'var(--sp-text-faint)' }} />
            </button>
          ))}
          {memberships.length === 0 ? (
            <div className="flex items-center gap-3 px-4 py-5 text-[13.5px] text-muted">
              <Building2 size={17} aria-hidden="true" />
              No workplaces on this account yet.
            </div>
          ) : null}
        </div>

        <button type="button" className="btn btn-ghost mt-4 w-full" onClick={() => void signOut()}>
          <LogOut size={15} aria-hidden="true" />
          Sign out
        </button>
      </div>
    </div>
  );
}
